import { SelectVal, FileType, SelectRoleVal, SecuresTypeVal } from '../types';
const pageOptions = (securesType: SecuresTypeVal, isWiki: boolean) => [
  {
    lebal: '拥有阅读权限的用户',
    desc:
      securesType === SecuresTypeVal.Share
        ? `文件及所在${isWiki ? '知识库' : '文件夹'}的全部协作者均可分享此文件`
        : `文件及所在${
            isWiki ? '知识库' : '文件夹'
          }的全部协作者均可下载、复制此文件`,
    roleId: SelectRoleVal.FileAll,
    value: SelectVal.ALL,
    disabled: false,
    tips: `如需设置该选项，请联系${
      isWiki ? '知识库' : '文件夹'
    }可管理协作者修改安全设置`,
  },
  {
    lebal: '拥有编辑权限的用户',
    desc:
      securesType === SecuresTypeVal.Share
        ? `文件及所在${isWiki ? '知识库' : '文件夹'}的可编辑协作者可分享此文件`
        : `文件及所在${
            isWiki ? '知识库' : '文件夹'
          }的可编辑协作者可下载、复制此文件`,
    roleId: SelectRoleVal.FileOnlyEdit,
    value: SelectVal.EDIT_OWNER,
    disabled: false,
    tips: `如需设置该选项，请联系${
      isWiki ? '知识库' : '文件夹'
    }可管理协作者修改安全设置`,
  },
  {
    lebal: '拥有可管理权限的用户',
    desc:
      securesType === SecuresTypeVal.Share
        ? `文件及所在${isWiki ? '知识库' : '文件夹'}的可管理协作者可分享此文件`
        : `文件及所在${
            isWiki ? '知识库' : '文件夹'
          }的可管理协作者可下载、复制此文件`,
    roleId: SelectRoleVal.FileOnlyOwner,
    value: SelectVal.OWNER,
    disabled: false,
    tips: `如需设置该选项，请联系${
      isWiki ? '知识库' : '文件夹'
    }可管理协作者修改安全设置`,
  },
];

const floderOptions = (securesType: SecuresTypeVal, isWiki: boolean) => [
  {
    lebal: '拥有阅读权限的用户',
    desc:
      securesType === SecuresTypeVal.Share
        ? '文件夹的全部协作者均可分享此文件夹和内部的文件'
        : '文件夹的全部协作者均可下载、复制此文件夹的文件',
    roleId: SelectRoleVal.FolderAll,
    value: SelectVal.ALL,
    disabled: false,
    tips: '如需设置该选项，请联系文件夹可管理协作者修改安全设置',
  },
  {
    lebal: '拥有编辑权限的用户',
    desc:
      securesType === SecuresTypeVal.Share
        ? '文件夹的可编辑协作者可分享此文件夹和内部的文件'
        : '文件夹的可编辑协作者可下载、复制此文件夹的文件',
    roleId: SelectRoleVal.FolderOnlyEdit,
    value: SelectVal.EDIT_OWNER,
    disabled: false,
    tips: '如需设置该选项，请联系文件夹可管理协作者修改安全设置',
  },
  {
    lebal: '拥有可管理权限的用户',
    desc:
      securesType === SecuresTypeVal.Share
        ? '文件夹的可管理协作者可分享此文件夹和内部的文件'
        : '文件夹的可管理协作者可下载、复制此文件夹的文件',
    roleId: SelectRoleVal.FolderOnlyOwner,
    value: SelectVal.OWNER,
    disabled: false,
    tips: '如需设置该选项，请联系文件夹可管理协作者修改安全设置',
  },
];

function getOptions(
  type: FileType,
  show = 3,
  securesType: SecuresTypeVal,
  isWiki = false
) {
  let opes = (type === FileType.Page
    ? pageOptions(securesType, isWiki)
    : floderOptions(securesType, isWiki) ?? []
  ).concat();
  switch (show) {
    case 1:
      opes[0].disabled = true;
      opes[1].disabled = true;
      break;
    case 2:
      opes[0].disabled = true;
      break;
  }
  return opes;
}

function fileTypeBySelectTitle(type: FileType) {
  if (type === FileType.Page) {
    return {
      shareTitle: '谁可以分享此文件',
      downloadTitle: '谁可以下载、复制此文件',
    };
  } else {
    return {
      shareTitle: '谁可以分享此文件夹和文件夹内的文件',
      downloadTitle: '谁可以下载、复制文件夹内的文件',
    };
  }
}

export { getOptions, fileTypeBySelectTitle, pageOptions, floderOptions };
